__webpack_public_path__ = __CLIENT_HOLOCRON_MODULE_MAP__.modules['arcade-root'].baseUrl;
import ModuleContainer from './components/ArcadeRoot';
export default ModuleContainer;
;
if (!global.BROWSER) {
  ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
    appCompatibility: "5.x || 6.x"
  });
}
;
ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
  providedExternals: {
    '@americanexpress/data-manager-utils': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '0.4.3',
      module: require('@americanexpress/data-manager-utils')
    },
    '@americanexpress/react-ddl': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '0.3.7',
      module: require('@americanexpress/react-ddl')
    },
    'react-intl': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '6.6.8',
      module: require('react-intl')
    }
  }
});
if (global.getTenantRootModule === undefined || global.rootModuleName && global.rootModuleName === 'arcade-root') {
  global.getTenantRootModule = () => ModuleContainer;
  global.rootModuleName = 'arcade-root';
}